import CourseRadioButton from '../../CourseRadioButton/CourseRadioButton';
import { durationDate, getStatusLabel, isEventOutdated } from '../helpers';
import type { CourseTimetableEvent } from '../types';
import styles from './CourseEventList.module.scss';

type CourseEventListProps = {
  onChangeRadioButton: (value: string) => void;
  selectedEventID: string;
  events: CourseTimetableEvent[];
  fieldName: string;
};

const CourseEventList = ({
  events,
  selectedEventID,
  onChangeRadioButton,
  fieldName = 'selectedEventID',
}: CourseEventListProps) => {
  return (
    <div className={styles.eventList}>
      {events.length === 0 && (
        <CourseRadioButton>Keine Termine</CourseRadioButton>
      )}
      {events.map(({ id, startDate, endDate, status }) => (
        <CourseRadioButton
          key={id}
          checked={selectedEventID === id}
          disabled={isEventOutdated(startDate) || 'ausgebucht' === status}
          onChange={onChangeRadioButton}
          name={fieldName}
          value={id}
        >
          <span className="visually-hidden">Termin vom</span>
          {durationDate(startDate, endDate)}
          <span className="visually-hidden">auswählen</span>
          {status && (
            <CourseRadioButton.SubText>
              {getStatusLabel(status)}
            </CourseRadioButton.SubText>
          )}
        </CourseRadioButton>
      ))}
    </div>
  );
};

export default CourseEventList;
